module.exports = __webpack_public_path__ + "static/media/dailekh2.1609bbbe.ogg";